// extracted by mini-css-extract-plugin
export var lockIcon = "style-module--lockIcon--56468";
export var protectedContent = "style-module--protectedContent--14840";